import React, { FunctionComponent } from 'react';
import styles from './Blocked.module.scss';
import { _t } from 'app/utils/i18n';
import { Link } from 'react-router-dom';
import { path } from 'app/utils/path';

const Blocked: FunctionComponent = () => {
  return (
    <>
      <div className={styles.SignIn}>
        <div className={styles.blockedAccount}>
          <div className={styles.content}>
            <p>{_t('login:This_account_is_blocked_Please_visit_your_admin')}</p>
            <Link to={path.auth.SIGN_IN}>
              <button>{_t('login:Thanks')}</button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Blocked;
